import React from "react";
interface Props {
  big?: boolean;
  pathFill?: string;
}
export default function Icon(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.big ? "74" : "48"}
      height={props.big ? "74" : "48"}
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M12 38.0006C16.4184 38.0006 20.0001 34.4188 20.0001 30.0005C20.0001 25.5822 16.4184 22.0005 12 22.0005C7.58174 22.0005 4 25.5822 4 30.0005C4 34.4188 7.58174 38.0006 12 38.0006Z"
        fill="#262C34"
      />
      <path
        d="M31.0005 44.0001C33.762 44.0001 36.0005 41.7615 36.0005 39C36.0005 36.2386 33.762 34 31.0005 34C28.2391 34 26.0005 36.2386 26.0005 39C26.0005 41.7615 28.2391 44.0001 31.0005 44.0001Z"
        fill="#262C34"
      />
      <path
        d="M32.0001 28.0001C38.6275 28.0001 44.0001 22.6275 44.0001 16.0001C44.0001 9.37262 38.6275 4 32.0001 4C25.3726 4 20 9.37262 20 16.0001C20 22.6275 25.3726 28.0001 32.0001 28.0001Z"
        fill="#262C34"
      />
      <line
        x1="31.75"
        y1="39"
        x2="31.75"
        y2="16"
        stroke="#252C34"
        strokeWidth="2.5"
      />
      <line
        x1="11.2832"
        y1="29.976"
        x2="31.2832"
        y2="15.976"
        stroke="#252C34"
        strokeWidth="2.5"
      />
      <line
        x1="10.58"
        y1="28.8927"
        x2="31.58"
        y2="39.8927"
        stroke="#252C34"
        strokeWidth="2.5"
      />
    </svg>
  );
}
